<ion-content class="ion-padding" slot="center">
  <div class="content-wrapper">
    <div class="signup-container">
      <div class="main-logo" (click)="moveToHome()">
        <img
          src="../../../../assets/icon-only.png"
          alt="logo"
          class="logo"
        />
      </div>
      
      <div class="login-title">
        <div class="brand-name">
          <span class="skill">Skill</span><span class="mantra">Mantra</span>
        </div>
        <span class="login-subtitle" routerLink="/home">{{signupContent[0]}}</span>
      </div>
      
      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <ion-input 
          class="space-input custom-input" 
          fill="outline" 
          labelPlacement="floating" 
          [label]="signupContent[1]" 
          appPhoneNumber 
          type="tel" 
          formControlName="phone" 
          required>
        </ion-input>
        <div *ngIf="signupForm.get('phone')?.invalid && (signupForm.get('phone')?.touched || signupForm.get('phone')?.dirty)" class="error-head">
          <small class="error-message" *ngIf="signupForm.get('phone')?.errors?.['required']">{{signupContent[2]}}</small>
          <small class="error-message" *ngIf="signupForm.get('phone')?.errors?.['pattern']">{{signupContent[3]}}</small>
        </div>

        <ion-input 
          class="space-input custom-input" 
          fill="outline" 
          labelPlacement="floating"
          [label]="signupContent[4]" 
          type="email" 
          formControlName="email" 
          required>
        </ion-input>
        <div *ngIf="signupForm.get('email')?.invalid && (signupForm.get('email')?.touched || signupForm.get('email')?.dirty)" class="error-head">
          <small class="error-message" *ngIf="signupForm.get('email')?.errors?.['required']">{{signupContent[5]}}</small>
          <small class="error-message" *ngIf="signupForm.get('email')?.errors?.['email']">{{signupContent[6]}}</small>
        </div>

        <ion-input 
          (ionInput)="checkPasswordStrength()" 
          class="space-input custom-input" 
          fill="outline" 
          labelPlacement="floating" 
          [label]="signupContent[7]" 
          type="password" 
          formControlName="password" 
          required>
          <!-- <ion-input-password-toggle slot="end"></ion-input-password-toggle> -->
        </ion-input>
        <div *ngIf="signupForm.get('password')?.invalid && (signupForm.get('password')?.touched || signupForm.get('password')?.dirty)" class="error-head">
          <small class="error-message" *ngIf="signupForm.get('password')?.errors?.['required']">{{signupContent[8]}}</small>
          <small class="error-message" *ngIf="signupForm.get('password')?.errors?.['minlength']">{{signupContent[9]}}</small>
        </div>

        <ion-input 
          (ionInput)="checkPasswordStrength()" 
          class="space-input custom-input" 
          fill="outline" 
          labelPlacement="floating" 
          [label]="signupContent[10]" 
          type="password" 
          formControlName="confirmPassword" 
          required>
          <!-- <ion-input-password-toggle slot="end"></ion-input-password-toggle> -->
        </ion-input>
        <div *ngIf="signupForm.get('confirmPassword')?.invalid && (signupForm.get('confirmPassword')?.touched || signupForm.get('confirmPassword')?.dirty)" class="error-head">
          <small class="error-message" *ngIf="signupForm.get('confirmPassword')?.errors?.['required']">{{signupContent[11]}}</small>
          <small class="error-message" *ngIf="signupForm.get('confirmPassword')?.errors?.['minlength']">{{signupContent[12]}}</small>
        </div>

        <div *ngIf="passwordStrength" class="password-strength-container">
          <p>{{signupContent[13]}}: {{ passwordStrength }}</p>
          <ul class="criteria-list">
            <li>
              <span
                [ngClass]="{
                  checkmark: passwordCriteria.hasUpperCase,
                  wrongmark: !passwordCriteria.hasUpperCase
                }"
              >
                <ion-icon
                  *ngIf="passwordCriteria.hasUpperCase"
                  name="checkmark-circle"
                ></ion-icon>
                <ion-icon
                  *ngIf="!passwordCriteria.hasUpperCase"
                  name="close-circle"
                ></ion-icon>
                {{signupContent[14]}}
              </span>
            </li>
            <li>
              <span
                [ngClass]="{
                  checkmark: passwordCriteria.hasLowerCase,
                  wrongmark: !passwordCriteria.hasLowerCase
                }"
              >
                <ion-icon
                  *ngIf="passwordCriteria.hasLowerCase"
                  name="checkmark-circle"
                ></ion-icon>
                <ion-icon
                  *ngIf="!passwordCriteria.hasLowerCase"
                  name="close-circle"
                ></ion-icon>
                {{signupContent[15]}}
              </span>
            </li>
            <li>
              <span
                [ngClass]="{
                  checkmark: passwordCriteria.hasNumbers,
                  wrongmark: !passwordCriteria.hasNumbers
                }"
              >
                <ion-icon
                  *ngIf="passwordCriteria.hasNumbers"
                  name="checkmark-circle"
                ></ion-icon>
                <ion-icon
                  *ngIf="!passwordCriteria.hasNumbers"
                  name="close-circle"
                ></ion-icon>
                {{signupContent[16]}}
              </span>
            </li>
            <li>
              <span
                [ngClass]="{
                  checkmark: passwordCriteria.hasSpecialChars,
                  wrongmark: !passwordCriteria.hasSpecialChars
                }"
              >
                <ion-icon
                  *ngIf="passwordCriteria.hasSpecialChars"
                  name="checkmark-circle"
                ></ion-icon>
                <ion-icon
                  *ngIf="!passwordCriteria.hasSpecialChars"
                  name="close-circle"
                ></ion-icon>
                {{signupContent[17]}}
              </span>
            </li>
            <li>
              <span
                [ngClass]="{
                  checkmark: passwordCriteria.minLength,
                  wrongmark: !passwordCriteria.minLength
                }"
              >
                <ion-icon
                  *ngIf="passwordCriteria.minLength"
                  name="checkmark-circle"
                ></ion-icon>
                <ion-icon
                  *ngIf="!passwordCriteria.minLength"
                  name="close-circle"
                ></ion-icon>
                {{signupContent[18]}}
              </span>
            </li>
            <li>
              <span
                [ngClass]="{
                  checkmark: passwordCriteria.passMatch,
                  wrongmark: !passwordCriteria.passMatch
                }"
              >
                <ion-icon
                  *ngIf="passwordCriteria.passMatch"
                  name="checkmark-circle"
                ></ion-icon>
                <ion-icon
                  *ngIf="!passwordCriteria.passMatch"
                  name="close-circle"
                ></ion-icon>
                {{signupContent[19]}}
              </span>
            </li>
          </ul>
          <div class="strength-bar">
            <div
              [ngClass]="passwordStrengthClass"
              [style.width.%]="passwordStrengthPercentage"
            ></div>
          </div>
        </div>

        <ion-button 
          expand="full" 
          type="submit" 
          class="signup-button" 
          [disabled]="signupForm.invalid || !passwordCriteria.passMatch || passwordStrengthPercentage < 75">
          {{signupContent[20]}}
        </ion-button>
      </form>
      
      <div class="separator">
        <span>OR</span>
      </div>
      
      <div class="samhita-login">
        <button (click)="loginWithSamhita()" class="samhita-button">
          <img height="30" width="50" src="../../../../assets/images/samita_small_logo.svg" alt="Samhita Logo" />
          <span>Sign up With Samhita</span>
        </button>
      </div>
      
      <p class="login-text">{{signupContent[21]}} <a routerLink="/login">{{signupContent[22]}}</a></p>
      
      <div class="powered-by">
        <strong>{{signupContent[23]}}</strong>
        <img src="../../../../assets/images/cg-logo.png" alt="Samhita logo" />
      </div>
    </div>
  </div>
</ion-content>